/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  select-account-actions.ts
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali
 *
 * @Date        : 05 Nov 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Madhu Gali - H175591
 * On            : 05 Nov 2019
 * Description   : ASDS-1318
 *
 * By            : sivateja
 * On            : Nov 8, 2019
 * Description   : ASDS-167: removed commented code
 *
 * By           : Deepthi Bachu(E844276)
 * On            : Jan 28, 2020
 * Description   : ASDS-2048 - Admin Functionality
 *
 * By            : Grandhi Srinivas (E528634)
 * On            : 17 Feb 2020
 * Description   : ASDS-403
 *
 * By            : H224423
 * On            : Apr 03 2020
 * Description   : ASDS-2190 - API error handling changes
 *
 * By            : H224423
 * On            : 09 Apr, 2020
 * Description   : ASDS-2497 APU SIT Fixes.
 *
 * By            : H422335
 * On            : Oct 09, 2020
 * Description   : ASDS-3035 Migration of backend URLs to Forge endpoints
 *
 * By            : H422335
 * On            : Oct 27, 2020
 * Description   : ASDS-3269 Migration of backend URLs to Forge endpoints
 ******************************************************************************/

import Action from './Action';
import { SelectAccountInfo, SaveAccountInfo } from '../../utils/checkout-interfaces';
import ActionConstants from '../action-constants';
import { AsdsReduxAction } from '../../../../types';
import AddressDetails from '../../API/select-account-api';
import ErrorActions from './error-actions';
import { isValueUndefined } from '../../../../utils/util';
import { logError, logInfo } from '../../../../utils/console-utility';
import ShippingAndBillingAPI from 'modules/checkout/API/shipping-billing-api';
import OrderSummaryActions from './order-summary-actions';
import ProductListingActions from './product-listing-actions';

class SelectAccountActions extends Action {

    static setSelectAccount(customerObject: SelectAccountInfo, userObj: SaveAccountInfo) {
        return async (dispatch, getState) => {

            ShippingAndBillingAPI.getCustomerCBDStatusAPI(customerObject.soldTo.sapNumber).then((response) => {
                dispatch(SelectAccountActions.dispatchCBDStatusCall(response));
            }).catch(error => {
                logError('Error in processing getCustomerCBDStatus ', error);
            });

            let orderSummaryRequired: boolean = false;
            const previousShipToSapNo = getState().selectAccount?.selectAccountDetails?.payload?.shipTo?.sapNumber;
            if (previousShipToSapNo && previousShipToSapNo !== customerObject.shipTo.sapNumber) {
                orderSummaryRequired = true;
            }

            let getProductListing = false;
            let getProductListingParams;

            const previousSoldToSapNo = getState().selectAccount?.selectAccountDetails?.payload?.soldTo?.sapNumber;
            if ((previousSoldToSapNo && (previousSoldToSapNo !== customerObject.soldTo.sapNumber))) {
                getProductListingParams = { soldTo: customerObject.soldTo.sapNumber };
                getProductListing = true;
            }

            const actionData: AsdsReduxAction = {
                type: ActionConstants.SET_SELECT_ACCOUNT,
                payload: {
                    selectAccountDetails: { ...customerObject },
                    isSuccess: true,
                },
            };
            dispatch(actionData);

            if(getProductListing){
                dispatch(ProductListingActions.getProductsForListing(getProductListingParams));
            }

            if (orderSummaryRequired) {
                dispatch(OrderSummaryActions.getOrderSummary(userObj.userId));
            }
        };
    }

    static dispatchCBDStatusCall = (response) => {
        return {
            type: ActionConstants.GET_CUSTOMER_CBD_STATUS,
            payload: {
                response: response || null,
            }
        };
    }
    static setAdminAddressDetails(searchStr: string, searchBy: string) {
        const account_details_promise = AddressDetails.getAddressDetails(searchStr, searchBy );
        logInfo("setAdminAddressDetails ", account_details_promise);
        // resetting address details
        return (dispatch) => {
            dispatch({
                type: ActionConstants.SET_ADMIN_ACCOUNT_ADDRESSES,
                payload: {
                    response: null,
                    isSuccess: false,
                    isFetching: true,
                }
            });
            return account_details_promise.then(response => {
                let adminAccountAddressDetails = {results: {account: response}};
                return dispatch({
                    type: ActionConstants.SET_ADMIN_ACCOUNT_ADDRESSES,
                    payload: {
                        response: isValueUndefined(response) ? null : adminAccountAddressDetails,
                        isSuccess: true,
                        isFetching: false,
                    }
                });
            }
            ).catch(error => {
                dispatch(ErrorActions.errorPageRedirectDispatch(error))
                dispatch({
                    type: ActionConstants.SET_ADMIN_ACCOUNT_ADDRESSES,
                    payload: {
                        response: null,
                        isSuccess: false,
                        isFetching: false,
                    }
                });
            });
        };
    }

    static updateSearchBy(searchBy: string) {
        return (dispatch) => {
          dispatch({
            type: ActionConstants.UPDATE_SEARCH_BY,
            payload: {
                searchBy: searchBy
            }
          });
        };
      }
}

export default SelectAccountActions;
